import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@material-ui/core/Typography';
import AdvancedSearch from './advanced-search/AdvancedSearch';

const styles = {
  root: {
    backgroundColor: 'white',
    display: 'flex',
    flexFlow: 'column',
    flex: '0 1 auto',
  },
  button: {
    borderRadius: 3,
    border: 0,
    height: 40,
    padding: '0 30px',
  },
  fullWidth: {
    width: '100%',
  },
  formRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 20px',
  },
  expansionPanelSummary: {
    minHeight: '48px !important',
    height: '48px',
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -20px rgba(0, 0, 0, 0.12)',
  },
};

export class SearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = { advSearchIsExpanded: false };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.expansionPanelClick = this.expansionPanelClick.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    const { advSearchIsExpanded } = this.state;
    if (advSearchIsExpanded) return;
    const { getSearchResult, searchParameter } = this.props;
    getSearchResult(searchParameter);
  }

  expansionPanelClick() {
    const { advSearchIsExpanded } = this.state;
    this.setState({ advSearchIsExpanded: !advSearchIsExpanded });
  }

  render() {
    const {
      classes: {
        root, button, fullWidth, formRow, expansionPanelSummary,
      },
      searchAttributes,
      getAdvancedSearchResults,
      advancedSearchFilters,
      addFilter,
      removeFilter,
      updateFilter,
      clearFilters,
      searchParameter,
      handleSearchParameterChange,
    } = this.props;
    const { advSearchIsExpanded } = this.state;
    return (
      <form onSubmit={this.handleSubmit} className={root}>
        {advSearchIsExpanded === false
          && (
          <div className={formRow}>
            <Input
              placeholder="Search by name or MTE number"
              value={searchParameter}
              onChange={handleSearchParameterChange}
              autoFocus
              fullWidth
            />
            <Button
              className={button}
              variant="contained"
              disabled={!searchParameter || advSearchIsExpanded}
              type="submit"
            >
              {'Search'}
            </Button>
          </div>
          )
        }
        <ExpansionPanel expanded={advSearchIsExpanded}>
          <ExpansionPanelSummary className={expansionPanelSummary} onClick={() => this.expansionPanelClick()} expandIcon={<FontAwesomeIcon icon="angle-down" />}>
            <Typography>
              {advSearchIsExpanded ? 'Go to basic search' : 'Go to advanced search'}
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className={fullWidth}>
              <AdvancedSearch
                advSearchIsExpanded={advSearchIsExpanded}
                searchAttributes={searchAttributes}
                getAdvancedSearchResults={getAdvancedSearchResults}
                advancedSearchFilters={advancedSearchFilters}
                addFilter={addFilter}
                removeFilter={removeFilter}
                updateFilter={updateFilter}
                clearFilters={clearFilters}
              />
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </form>
    );
  }
}

SearchForm.propTypes = {
  getSearchResult: PropTypes.func.isRequired,
  classes: PropTypes.shape({ root: PropTypes.string, button: PropTypes.string }).isRequired,
  searchAttributes: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  getAdvancedSearchResults: PropTypes.func.isRequired,
  advancedSearchFilters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  updateFilter: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  searchParameter: PropTypes.string.isRequired,
  handleSearchParameterChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(SearchForm);



// WEBPACK FOOTER //
// ./src/components/search/SearchForm.jsx